package com.dotdrives.web.pages.onboarding

import com.dotdrives.controller.OnboardingController
import com.dotdrives.controller.OnboardingUiState
import react.FC
import react.Props
import react.dom.html.ReactHTML.a
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.span
import web.cssom.ClassName

external interface OnboardingPageProps : Props {
    var controller: OnboardingController
    var state: OnboardingUiState
    var email: String
    var canWrite: Boolean
    var onImportGivers: () -> Unit
    var onExploreDashboard: () -> Unit
}

val OnboardingPage = FC<OnboardingPageProps> { props ->
    val state = props.state

    div {
        className = ClassName("onboarding-page")

        div {
            className = ClassName("onboarding-float-dot onboarding-float-dot-orange")
            ariaHidden = true
        }
        div {
            className = ClassName("onboarding-float-dot onboarding-float-dot-blue")
            ariaHidden = true
        }
        div {
            className = ClassName("onboarding-float-dot onboarding-float-dot-green")
            ariaHidden = true
        }

        div {
            className = ClassName("onboarding-rail")
            a {
                href = "#/"
                ariaLabel = "Dot Drives home"
                className = ClassName("onboarding-brand dot-home-link")
                span {
                    className = ClassName("onboarding-brand-mark")
                    ariaHidden = true
                    +"•••"
                }
                +" dot drives"
            }
            div {
                className = ClassName("onboarding-rail-content")
                div {
                    className = ClassName("onboarding-rail-title dot-heading")
                    +"Let's get your first Drive moving."
                }
                p {
                    className = ClassName("onboarding-rail-copy")
                    +"Four quick steps and your whole team is fundraising from one place — with the proven process baked in."
                }
                div {
                    className = ClassName("onboarding-progress-track")
                    div {
                        className = ClassName("onboarding-progress-dot")
                        ariaHidden = true
                    }
                }
                div {
                    className = ClassName("onboarding-step-list")
                    onboardingSteps.forEachIndexed { index, step ->
                        val number = index + 1
                        val complete = state.finished || state.step > number
                        val active = !state.finished && state.step == number
                        div {
                            className = ClassName(
                                buildString {
                                    append("onboarding-step-item")
                                    if (active) append(" onboarding-step-item-active")
                                    if (complete) append(" onboarding-step-item-complete")
                                },
                            )
                            div {
                                className = ClassName("onboarding-step-number")
                                +(if (complete) "✓" else number.toString())
                            }
                            div {
                                div {
                                    className = ClassName("onboarding-step-name")
                                    +step.title
                                }
                                div {
                                    className = ClassName("onboarding-step-subtitle")
                                    +step.subtitle
                                }
                            }
                        }
                    }
                }
            }
        }

        div {
            className = ClassName("onboarding-stage")
            div {
                className = ClassName(
                    "onboarding-panel" + if (state.finished) " onboarding-panel-finished" else "",
                )
                if (state.finished) {
                    FinishedView {
                        this.state = state
                        onExploreDashboard = props.onExploreDashboard
                    }
                } else {
                    when (state.step) {
                        1 -> ProfileStep {
                            this.state = state
                            email = props.email
                            onProfileChange = props.controller::setProfile
                            onContinue = props.controller::submitProfile
                        }
                        2 -> OrgStep {
                            this.state = state
                            onOrgChange = props.controller::setOrg
                            onBack = props.controller::back
                            onContinue = props.controller::submitOrg
                        }
                        3 -> InviteStep {
                            controller = props.controller
                            this.state = state
                            canWrite = props.canWrite || state.createdOrgId != null
                            onBack = props.controller::back
                            onSkip = props.controller::skipStep
                            onContinue = props.controller::submitInvites
                        }
                        else -> GiversStep {
                            this.state = state
                            onBack = props.controller::back
                            onImport = props.onImportGivers
                            onSkip = props.controller::skipStep
                        }
                    }
                }
            }
        }
    }
}
